import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import { ORGANIZATION_NAME } from '../../branding'

const milestones = [
  {
    year: "2019",
    icon: "💼",
    caption: "Started Operations",
    description: `We began our journey in Kileleshwa in 2019 with 2 students and laid the foundation for ${ORGANIZATION_NAME}.`
  },
  {
    year: "2020",
    icon: "⚙️",
    caption: "Smart Campus Launch",
    description: "We developed our first Version of Smart Campus and started onboarding students during the COVID-19 Lockdown. We accumulate alot of debts during this year of operation."
  },
  {
    year: "2021",
    icon: "📊",
    caption: "Building Brand and Market Validation",
    description: `This year we concentrated on building the ${ORGANIZATION_NAME} brand, positioning it strongly in the market and growing student interest.`
  },
  {
    year: "2022",
    icon: "📈",
    caption: "Building Brand and Market Validation",
    description: `We continued strengthening the ${ORGANIZATION_NAME} brand, refining our market position and expanding enrolment momentum.`
  },
  {
    year: "2023",
    icon: "💰",
    caption: "Growth and Profitability",
    description: "Best year so for with 118 students and a profit of 2M. Did lots of improvements at the campus such as renovations, new furniture, new curriculum and more."
  },
    {
    year: "2024",
    icon: "💰",
    caption: "Growth Stagnation",
    description: "Worst year since COVID-19, trying to settle a 1.2M accrued debt from 2019 that we had postponed so that we could concentrate on growth and stabilisation."
  },
  {
    year: "2025",
    icon: "💰",
    caption: "Income Stabilisation",
    description: "We stabilised income and repaid our rent debt. A slight improvement in income from 2024."
  }
]




function MilestoneTracker() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <div className="clientsComp">
          <div className="dataCompTop">
            <h5>Milestones Chart</h5>
          </div>

          {/* Vertical Zig-Zag Timeline */}
          <div className="timelineContainer">
            {milestones.map((m, index) => (
              <div
                key={index}
                className={`timelineItem ${index % 2 === 0 ? "left" : "right"}`}
              >
                <div className="timelineContent">
                  <div className="timelineIcon">{m.icon}</div>
                  <p className="timelineYear">{m.year}</p>
                  <div className="timelineBox">
                    <p className="timelineCaption">{m.caption}</p>
                    <p className="timelineDesc">{m.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  )
}

export default MilestoneTracker
